// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"HintPopupMobile_titleWrapper__3Mo9X","textWrapper":"HintPopupMobile_textWrapper__2EznH","modalWrapper":"HintPopupMobile_modalWrapper__3zHA8"};